import ApplicationController from '@app/javascript/controllers/application_controller'

export default class extends ApplicationController {
  static targets = ['node', 'selectedNode']
  static values = { defaultNodeId: String }

  doConnect() {
    const nodeSelectedId = this.getParam(this.selectedNodeTarget, 'node-selected')

    if (nodeSelectedId) {
      this.selectNodeWithId(nodeSelectedId) || this.selectNodeWithId('placeholder')
    }
  }

  selectNode(event) {
    if (this.hasParam(event.currentTarget, 'node-id')) {
      this.updateNodeSelected(event.currentTarget)
    } else {
      const selectedNodeId = this.getParam(event.currentTarget, 'node-ref')
      this.selectNodeWithId(selectedNodeId)
    }
  }

  selectDefaultNode(event) {
    this.selectNodeWithId(this.defaultNodeIdValue)
  }

  selectNodeWithIdFromEvent(event) {
    this.selectNodeWithId(this.getParam(event.currentTarget, 'node-ref'))
  }

  selectNodeWithId(id) {
    const nodeSelected = this.getNodeWithId(id)
    return this.updateNodeSelected(nodeSelected)
  }

  updateNodeSelected(node) {
    if (node) {
      const node_id = this.getParam(node, 'node-id')
      this.selectedNodeTarget.innerHTML = node.innerHTML
      this.setParam(this.selectedNodeTarget, 'node-selected', node_id)

      return true
    }

    return false
  }

  getNodeWithId(id) {
    let nodeSelected = null
    this.nodeTargets.some((node) => {
      if (this.getParam(node, 'node-id') === id) {
        nodeSelected = node
        return true
      }
    })
    return nodeSelected
  }
}
